// extracted by css-extract-rspack-plugin
export default {"FixedSizeVirtualList":"RefsList-module__FixedSizeVirtualList__p13VN0T"};